import React, { useEffect, useState } from "react";
import {thingsBoardMicroserviceUrl} from "../../../../microservices/thingsboard_microservice.js";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/NewCustomer.css";
const NewCustomer = ({showNewCustomerWindow,setShowNewCustomerWindow,access_token,selectedServerUrl,setCustomersFetched}) =>{
    const [formValues,setFormValues] = useState({
        title:'',
        phone:'',
        email:'',
        country:'select',
        city:'',
        state:'',
        zip:'',
        address:'',
        address2:'',
        additionalInfo:{
            description:''
        }
    });
    const handleFormValueChange = (e) =>{
        const {name,value} = e.target;
        if (name === "description") {
            setFormValues(prevValues => ({
                ...prevValues,
                additionalInfo: {
                    ...prevValues.additionalInfo,
                    description: value
                }
            }));
        }
        else setFormValues(prevValues => ({...prevValues,[name]:value}));
    };
    async function createCustomer(){
        try{
            const customerModel = {
                serverUrl:selectedServerUrl,
                title:formValues.title,
                phone:formValues.phone,
                email:formValues.email,
                country:formValues.country,
                city:formValues.city,
                state:formValues.state,
                zip:formValues.zip,
                address:formValues.address,
                address2:formValues.address2,
                additionalInfo:formValues.additionalInfo
            };
            const url = `${thingsBoardMicroserviceUrl}/tenants/customers/create`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${access_token}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(customerModel)
            });
            if(response.ok){
                setFormValues({
                    title:'',
                    phone:'',
                    email:'',
                    country:'select',
                    city:'',
                    state:'',
                    zip:'',
                    address:'',
                    address2:'',
                    additionalInfo:{
                        description:''
                    }
                });
                setCustomersFetched(false);
                setShowNewCustomerWindow(false);
            }
        }
        catch(error){
            console.error(error);
        }
    }
    if(!showNewCustomerWindow) return null;
    return(
        <div className="new-customer-container">
            <div className="new-customer-header">
                <h3>Add customer</h3>
                <p onClick={() => {
                    setFormValues({
                        title:'',
                        phone:'',
                        email:'',
                        country:'select',
                        city:'',
                        state:'',
                        zip:'',
                        address:'',
                        address2:'',
                        additionalInfo:{
                            description:''
                        }
                    });
                    setShowNewCustomerWindow(false);
                }}>&#10006;</p>
            </div>
            <div className="new-customer-body">
                <div className="new-customer-property-component">
                    <p>Title*</p>
                    <input
                        name="title"
                        value={formValues.title}
                        onChange={handleFormValueChange}
                    />
                </div>
                <div className="new-customer-property-component">
                    <p>Description</p>
                    <input
                        name="description"
                        value={formValues.additionalInfo.description}
                        onChange={handleFormValueChange}
                    />
                </div>
                <div className="new-customer-property-component">
                    <p>Country*</p>
                    <select
                        name="country"
                        value={formValues.country}
                        onChange={handleFormValueChange}
                    >
                        <option value="select" disabled>Select</option>
                        <option value="Kenya">Kenya</option>
                        <option value="Uganda">Uganda</option>
                        <option value="Tanzania">Tanzania</option>
                        <option value="Rwanda">Rwanda</option>
                        <option value="Burundi">Burundi</option>
                        <option value="Ethiopia">Ethiopia</option>
                        <option value="Somalia">Somalia</option>
                    </select>
                </div>
                <div className="new-customer-property-component">
                    <p>City*</p>
                    <input
                        name="city"
                        value={formValues.city}
                        onChange={handleFormValueChange}
                    />
                </div>
                <div className="new-customer-property-component">
                    <p>Email address*</p>
                    <input
                        name="email"
                        value={formValues.email}
                        onChange={handleFormValueChange}
                    />
                </div>
                <div className="new-customer-property-component">
                    <p>Phone number*</p>
                    <input
                        name="phone"
                        value={formValues.phone}
                        onChange={handleFormValueChange}
                    />
                </div>
                <div className="new-customer-property-component">
                    <p>Address 1</p>
                    <input
                        name="address"
                        value={formValues.address}
                        onChange={handleFormValueChange}
                    />
                </div>
                <div className="new-customer-property-component">
                    <p>Address 2</p>
                    <input
                        name="address2"
                        value={formValues.address2}
                        onChange={handleFormValueChange}
                    />
                </div>
                <div className="new-customer-property-component">
                    <p>Zip/Postal code</p>
                    <input
                        name="zip"
                        value={formValues.zip}
                        onChange={handleFormValueChange}
                    />
                </div>
            </div>
            <div className="new-customer-container-buttons">
                <button onClick={() => {
                    setFormValues({
                        title:'',
                        phone:'',
                        email:'',
                        country:'select',
                        city:'',
                        state:'',
                        zip:'',
                        address:'',
                        address2:'',
                        additionalInfo:{
                            description:''
                        }
                    });
                    setShowNewCustomerWindow(false);
                }}>Cancel</button>
                <button onClick={() => {createCustomer()}}>Add</button>
            </div>
        </div>
    );
};
export default NewCustomer;